<template>
  <div class="flex cursor-default flex-row items-center !text-base">
    <span>{{ props.title }}</span>
  </div>
</template>

<script setup lang="ts">
type PropsType = {
  title: string;
};

const props = defineProps<PropsType>();
</script>
